import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: "#048BCC",
        secondary: "#344955",
        accent: "#FF9800",
        error: "#B71C1C"
      }
    }
  } 
});